export enum ProductStatusEnum {
	FULFILLED = 'FULFILLED',
  NOT_FULFILLED = 'NOT_FULFILLED',
	CANCELLED = 'CANCELLED'
}
